import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.SearchOffersIndex__V2_GetClustersForMap];

export const getQueryKey = (): QueryKey => [EQueryKeys.SearchOffersIndex__V2_GetClustersForMap];
